import { useState } from "react";
import { X, Phone, ThumbsUp, ThumbsDown } from "@phosphor-icons/react";
import { toast } from "sonner";
import { teleproApi } from "../../lib/teleproApi";
import RoleplayChat from "./RoleplayChat";
import TrainingEvaluation from "./TrainingEvaluation";

function Lesson({ module, onStart, starting }) {
  return (
    <div className="space-y-3" data-testid="training-lesson">
      <p className="text-sm"><span className="font-semibold">Objectif : </span>{module.goal}</p>
      <ul className="space-y-1.5">
        {module.points.map((p, i) => <li key={i} className="text-sm flex gap-2"><span className="text-primary font-bold">{i + 1}.</span>{p}</li>)}
      </ul>
      <div className="border border-emerald-200 bg-emerald-50 rounded-sm p-2.5 text-sm">
        <div className="text-[10px] uppercase tracking-widest font-bold text-emerald-700 flex items-center gap-1"><ThumbsUp size={11}/> À dire</div>
        « {module.good} »
      </div>
      <div className="border border-red-200 bg-red-50 rounded-sm p-2.5 text-sm">
        <div className="text-[10px] uppercase tracking-widest font-bold text-red-700 flex items-center gap-1"><ThumbsDown size={11}/> À éviter</div>
        « {module.bad} »
      </div>
      <div className="bg-muted/50 border border-border rounded-sm p-2.5 text-xs">
        <span className="font-semibold">Ton prospect : </span>{module.persona}
      </div>
      <button type="button" onClick={onStart} disabled={starting}
        className="w-full bg-primary text-primary-foreground rounded-sm py-2.5 text-sm font-semibold flex items-center justify-center gap-2 hover:opacity-90 disabled:opacity-60"
        data-testid="training-start-roleplay">
        <Phone size={15} weight="fill"/> {starting ? "Le prospect décroche…" : "Commencer le jeu de rôle"}
      </button>
    </div>
  );
}

export default function TrainingModal({ module, passScore, onClose }) {
  const [session, setSession] = useState(null);
  const [starting, setStarting] = useState(false);

  const start = async () => {
    setStarting(true);
    try {
      const r = await teleproApi.post(`/training/${module.id}/start`);
      setSession(r.data);
    } catch {
      toast.error("Impossible de démarrer l'exercice");
    } finally {
      setStarting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[85] bg-foreground/60 backdrop-blur-sm flex items-end sm:items-center justify-center p-2 sm:p-6"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }} data-testid="training-modal">
      <div className="bg-background border border-border rounded-sm shadow-xl w-full max-w-xl max-h-[92vh] flex flex-col">
        <div className="flex items-center justify-between gap-2 px-4 py-3 border-b border-border bg-primary/5">
          <div className="min-w-0">
            <div className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground">Formation</div>
            <div className="font-display font-semibold text-sm truncate">{module.title}</div>
          </div>
          <button type="button" onClick={onClose} className="p-1.5 text-muted-foreground hover:text-foreground" aria-label="Fermer" data-testid="training-close">
            <X size={16}/>
          </button>
        </div>
        <div className="overflow-y-auto p-3 sm:p-4">
          {!session ? <Lesson module={module} onStart={start} starting={starting}/>
            : session.evaluation
              ? <TrainingEvaluation evaluation={session.evaluation} passScore={passScore} onRetry={() => setSession(null)}/>
              : <RoleplayChat session={session} onUpdate={setSession}/>}
        </div>
      </div>
    </div>
  );
}
